import { render, staticRenderFns } from "./CoveShed.vue?vue&type=template&id=23b15350&scoped=true&"
import script from "./CoveShed.vue?vue&type=script&lang=js&"
export * from "./CoveShed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b15350",
  null
  
)

export default component.exports